// resolveLocationStepAction — pure resolution of the hotel location step.
//
// Extracted verbatim from `AIChatBot.js` (module-level `resolveLocationStepAction`)
// as part of the behavior-preserving refactor (issue #240). Given the user's
// text and profile, it resolves the chosen `locationHint` (matching a known
// LOCATION_OPTIONS entry by `value` or `label`, else the raw text) and the
// user's saved hotel brand (via getSavedHotelBrand).
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

import { LOCATION_OPTIONS } from './hotelFlowOptions';
import getSavedHotelBrand from './getSavedHotelBrand';

/**
 * @typedef {Object} LocationStepResult
 * @property {string} locationHint
 * @property {string|null} savedBrand
 */

/**
 * Resolves the location hint and saved brand for the hotel location step.
 *
 * @param {string} userText - The user's message text (or selected option value).
 * @param {Object|null|undefined} userProfile - The user profile (may be missing).
 * @returns {LocationStepResult} The resolved location hint and saved brand.
 */
export function resolveLocationStepAction(userText, userProfile) {
  const locOpt = LOCATION_OPTIONS.find(o => o.value === userText || o.label === userText);
  const locationHint = locOpt ? locOpt.value : userText;
  const savedBrand = getSavedHotelBrand(userProfile);
  return { locationHint, savedBrand };
}

export default resolveLocationStepAction;
